<div *ngIf="isAdmin" class="row margin-bottom-20">
	<div fxFlex fxLayoutGap="5px">
		<button (click)="navigate()" mat-raised-button color="primary">
			Edit Pay Table
		</button>
		<button [disabled]="!this.numberOfTrips" (click)="print()" mat-raised-button color="primary">
			Print
		</button>
	</div>
</div>
<div class="pilot-pay-tables" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutWrap="wrap">
	<div
		class="pilot-pay-left no-padding-left"
		fxFlex.xs="100"
		fxFlex.sm="100"
		fxFlex.md="60"
		fxFlex.lg="60"
		fxFlex.xl="60"
	>
		<div>
			<app-pay-scales-years-of-service-card
				[isAddRecord]="isAddRecord"
				[isApRatingPayScale]="payScale.isApRatingPayScale"
				[isInstructorPayScale]="payScale.isInstructorPayScale"
				[numberOfTrips]="numberOfTrips"
				[payScale]="payScale"
				[yearOfServiceToHighlight]="yearsOfService"
				(onChange)="onYearOfServiceRecordsChange($event)"
			>
			</app-pay-scales-years-of-service-card>
		</div>

		<div>
			<app-pay-scales-pilots-card
				[pilots]="pilots"
				[isInstructorPayScale]="payScale.isInstructorPayScale"
				[isApRatingPayScale]="payScale.isApRatingPayScale"
				[constantAPBonus]="payScale.constantApBonus"
				[isAddRecord]="isAddRecord"
			></app-pay-scales-pilots-card>
		</div>
	</div>
	<div
		*ngIf="payScale"
		class="pilot-pay-right column"
		fxFlex.xs="100"
		fxFlex.sm="100"
		fxFlex.md="40"
		fxFlex.lg="40"
		fxFlex.xl="40"
	>
		<app-pay-scales-trips-card
			[payScale]="payScale"
			(estimatedNumberOfTrips)="onEstimatedNumberOfTrips($event)"
		></app-pay-scales-trips-card>
	</div>
</div>
<div fxLayout="row" *ngIf="payScaleChanges && payScaleChanges.length">
	<div fxFlex.gt-sm="100%" fxFlex="100">
		<mat-card class="expander">
			<mat-card-title>
				<div>Future Changes</div>
				<div fxFlex></div>
				<button type="button" mat-icon-button class="ml-1" (click)="futureChangesToggle = !futureChangesToggle">
					<mat-icon *ngIf="!futureChangesToggle">keyboard_arrow_down</mat-icon>
					<mat-icon *ngIf="futureChangesToggle">keyboard_arrow_up</mat-icon>
				</button>
			</mat-card-title>
			<hr />
			<div [hidden]="!futureChangesToggle">
				<app-changes-display [history]="payScaleChanges"></app-changes-display>
			</div>
		</mat-card>
	</div>
</div>
<div fxLayout="row" *ngIf="payScaleHistory && payScaleHistory.length">
	<div fxFlex.gt-sm="100%" fxFlex="100">
		<mat-card class="expander">
			<mat-card-title>
				<div>History</div>
				<div fxFlex></div>
				<button type="button" mat-icon-button class="ml-1" (click)="historyToggle = !historyToggle">
					<mat-icon *ngIf="!historyToggle">keyboard_arrow_down</mat-icon>
					<mat-icon *ngIf="historyToggle">keyboard_arrow_up</mat-icon>
				</button>
			</mat-card-title>
			<hr />
			<div [hidden]="!historyToggle">
				<app-changes-display [history]="payScaleHistory"></app-changes-display>
			</div>
		</mat-card>
	</div>
</div>
